/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import LocalizationConsumer from '../../../l10n/localization-context';
import InsertAnchor from '../../insert-anchor';
import Modal from '../../modal';

class InsertAnchorDialog extends React.Component
{
  static propTypes = {
    isEditMode: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
  };

  static defaultProps = {
    isEditMode: false
  };

  constructor(props)
  {
    super(props);

    const { value } = this.props;

    this.state = { value };
  }

  getButtons = () =>
  {
    const { value } = this.state;
    const { onSave, onCancel, isEditMode } = this.props;
    const saveStateValue = () => onSave(value);
    const saveButtonName = isEditMode ? <LocalizationConsumer id="insert-anchor-dialog.button-edit-anchor" /> :
    <LocalizationConsumer id="insert-anchor-dialog.button-insert-anchor" />;

    return [
      {
        name: saveButtonName,
        buttonHandler: saveStateValue,
        isDisabled: !value
      },
      {
        name: <LocalizationConsumer id="insert-anchor-dialog.button-cancel" />,
        buttonHandler: onCancel
      }
    ];
  };

  handleChange = (value) =>
  {
    const cleanedValue = value.replace(/[^A-Za-z0-9_:.-]+/g, '').replace(/^[^A-Za-z]+/, '');
    this.setState({ value: cleanedValue });
  };

  render()
  {
    const { isEditMode, onCancel } = this.props;
    const { value } = this.state;

    return (
      <Modal
        onCloseDialogClick={onCancel}
        size={{ width: 550 }}
      >
        <Modal.Header>
          <LocalizationConsumer
            id={isEditMode ? 'insert-anchor-dialog.header.edit' :
              'insert-anchor-dialog.header.insert'}
          />
        </Modal.Header>
        <Modal.Content>
          <InsertAnchor value={value} onChange={this.handleChange} isEditMode={isEditMode} />
        </Modal.Content>
        <Modal.Footer>
          {this.getButtons()}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default InsertAnchorDialog;